import React from "react";
import styled from "styled-components";
import { Link } from "@reach/router";

export default function LoginBtn() {
  const HeaderBtn = styled.button`
    font-family: Poppins !important;
    font-style: normal;
    font-weight: bold;
    font-size: 3vh;
    text-align: center;
    letter-spacing: 0.005em;
    color: ${(props) => props.theme.colors.text_color_dark_mode};
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 9999;
  `;

  const TextWrapper = styled.section`
  z-index: 9999;
  background: transparent;
  display: flex !important;
  justify-content: space-between;
  width: 100%;
  margin-top: 15px;
}
`;

  return (
    <>
      <TextWrapper>
        <div style={{ marginLeft: "10px", marginTop: "40px" }}>
          <Link to="/login">
            <HeaderBtn>Login</HeaderBtn>
          </Link>
        </div>
      </TextWrapper>
    </>
  );
}
